import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// import { Store } from '@ngrx/store';
// import * as fromLayout from '../home/store/reducers';
// import * as LayoutActions from '../home/store/actions/layout.actions';

import { AuthService } from '../auth/auth.service';
import { ToastService } from '../toast/toast.service';
// import { SidebarService } from '../sidebar/sidebar.service';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService, public toastService: ToastService, public router: Router, private route: ActivatedRoute) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        // TODO: decide what to do with this. Doesn't make sense to logout just because of a 401 or 403
        if (err.status === 401) {
          // auto logout if 401 response returned from api
          if (localStorage.getItem('expires_at') && !this.authenticationService.isAuthenticated()) {
            this.authenticationService.clearLocalStorage();
            this.toastService.addMessage({ text: `Your session has expired. Please login.`, error: true });
            this.router.navigate(['../login']);
          } else {
            this.toastService.addMessage({ text: `You do not have access to view this item.`, error: true, displayTime: 8000 });
          }
        }

        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
